import type { RailwayAccount } from '@cli-types/next-adapter/railway.js'

export function isRailwayAccount(value: unknown): value is RailwayAccount {
  if (!value || typeof value !== 'object') return false
  const account = value as Record<string, unknown>
  return (
    typeof account.email === 'string' &&
    Array.isArray(account.workspaces) &&
    account.workspaces.every(
      (workspace) =>
        workspace !== null &&
        typeof workspace === 'object' &&
        typeof (workspace as Record<string, unknown>).id === 'string' &&
        typeof (workspace as Record<string, unknown>).name === 'string'
    )
  )
}
